export default __webpack_public_path__ + "static/media/logo-light.72528c4e.svg";